import { useEffect, useState } from "react";

import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import { ReactComponent as GALogo } from "assets/Logos-Xylem-goAigua/Global-Header-Dark-LetsSolveWater.svg";
import { ReactComponent as GALogoLight } from "assets/Logos-Xylem-goAigua/Global-Header-Light-LetsSolveWater.svg";
import { ReactComponent as GALogoManual } from "assets/icons/base/manual.svg";

import {
    FAVICON_DARK_PATH,
    FAVICON_LIGHT_PATH,
    REACT_APP_MANUAL_URL,
    REACT_APP_URL_LOGO_MENU,
    REACT_APP_VERSION,
} from "utils/environment";
import { getEnvVariable } from "utils/environment";

import PreferencesMenu from "./preferencemenu";
import PreferencesProfile from "./preference-profile";
import store from "redux/store";
import { THEME } from "enums/global.enum";
import { Application } from "types/generic";
import VersionIcon from "./version-icon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestion } from "@fortawesome/pro-light-svg-icons";
import { useIntl } from "react-intl";

type MainLayoutHeaderProps = {
    applications: Application[];
};

const MainLayoutHeader = ({ applications }: MainLayoutHeaderProps) => {
    const currentTheme = store.getState().app.theme;

    const manualURL = getEnvVariable(REACT_APP_MANUAL_URL);

    const intl = useIntl();

    const [isBoxOpen, setIsBoxOpen] = useState<boolean>(false);

    const [logoUrl, setLogoUrl] = useState(
        `${getEnvVariable(REACT_APP_URL_LOGO_MENU)}`
    );
    const [imageLogoError, setImageLogoError] = useState<boolean>(true);

    const history = useHistory();

    //@ts-ignore
    const redux = useSelector((state) => state.keycloak.userName);

    const onError = () => {
        setImageLogoError(false);
    };

    useEffect(() => {
        const darkFavicon = getEnvVariable(FAVICON_DARK_PATH);
        const lightFavicon = getEnvVariable(FAVICON_LIGHT_PATH);

        const setFavIcon = () => {
            const faviconElement = document.getElementById(
                "favicon"
            ) as HTMLLinkElement;

            faviconElement.href =
                currentTheme === THEME.DARK ? darkFavicon : lightFavicon;
        };

        setFavIcon();
    }, [currentTheme]);

    return (
        <div className="c-main-layout-header">
            <div className="c-main-layout-header__bar-menu"></div>
            <div className="c-main-layout-header__logo">
                {currentTheme === THEME.DARK ? <GALogo /> : <GALogoLight />}

                {logoUrl != "" && imageLogoError && (
                    <div className="c-main-layout-header__logo-right">
                        <img
                            width="auto"
                            height="30"
                            src={logoUrl}
                            onError={onError}
                        />
                    </div>
                )}
            </div>
            <div className="c-main-layout-header__icon-bar">
                {manualURL !== "" && (
                    <div className="c-main-layout-header__icon-version">
                        <VersionIcon
                            icon={<GALogoManual />}
                            message={intl.formatMessage({
                                id: "app.manual.access",
                            })}
                            url={manualURL}
                        />
                    </div>
                )}

                <div className="c-main-layout-header__action-list">
                    <PreferencesMenu />
                </div>

                <div className="c-main-layout-header__user-menu">
                    <PreferencesProfile />
                </div>
            </div>
        </div>
    );
};

export default MainLayoutHeader;
